import {useCallback} from "react";
import {
    confirmSignIn,
    ConfirmSignInInput
} from "aws-amplify/auth";
import {pushAnalyticsEvent} from "@flexinet/analytics-components";
import {showNotification} from "@mantine/notifications";
import {AiOutlineExclamation} from "react-icons/ai";


interface ConfirmSignInFormFields {
    challengeResponse: string
}

export const useConfirmSignInForm = () => {

    const initialValues: ConfirmSignInFormFields = {
        challengeResponse: '',
    };

    const submitForm = async (values: ConfirmSignInFormFields) => {

        const input = {
            challengeResponse: values.challengeResponse,
        } as ConfirmSignInInput;

        try {
            const output = await confirmSignIn(input)
            console.debug(output)

            pushAnalyticsEvent('confirm_sign_in')


        } catch (e: unknown) {

            console.error(e)

            const message = e instanceof Error ? e.message : 'Sign-in confirmation failed';

            showNotification({
                                 title: 'Error',
                                 icon: <AiOutlineExclamation/>,
                                 message,
                                 color: 'red',
                             })

        }


    }

    const handleSubmit = useCallback(
        (values: ConfirmSignInFormFields) => {
            return submitForm(values)
                .then(() => {
                    console.log('Form submitted!');
                });
        },
        [],
    );

    return {
        initialValues,
        handleSubmit,
    };
};
